import React from 'react';
import styles from './VotingSession.module.css';
import classNames from 'classnames';
import type VotingSessionWidget from '../../../widgets/VotingSessionWidget';
import Result from './Result';
import { ApplicationView } from '@aha-app/mvc';

const StandardVotingSessionResults: React.FC<{
  widget: VotingSessionWidget;
}> = ({ widget }) => {
  return (
    <div>
      <ol
        className={classNames('side-panel__list', styles.votingResultSummary)}
      >
        {widget &&
          [...Object.entries(widget.votesByObject())]
            .sort(([, count1], [, count2]) => count2 - count1)
            .map(([id]) => <Result key={id} widget={widget} objectId={id} />)}
      </ol>
    </div>
  );
};

export default ApplicationView(StandardVotingSessionResults);
